import { render, staticRenderFns } from "./DepartmentChip.vue?vue&type=template&id=44d7b7f6"
import script from "./DepartmentChip.vue?vue&type=script&lang=js"
export * from "./DepartmentChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports